import React, {useMemo} from 'react'
import {TransformerLayerProps} from './TransformerLayer'
import {canvasElementsRegistry} from '../elements/CanvasElementsRegistry'

export function TransformerManager(props: TransformerLayerProps) {
  const TransformerLayerComponent = useMemo(
    () => canvasElementsRegistry[props.element.shapeType]?.transformerLayer,
    [props.element.shapeType]
  )

  if (!TransformerLayerComponent) {
    return null
  }

  return (
    <TransformerLayerComponent
      element={props.element}
      mode={props.mode}
      shapeRef={props.shapeRef}
      transformerRef={props.transformerRef}
      onChange={props.onChange}
      transformerLayerProps={props.transformerLayerProps}
    />
  )
}
